import { Slot } from '@radix-ui/react-slot';

import cn from '../../../utils/cn';

export interface MenuItemProps extends React.ComponentProps<typeof Slot> {
  asChild?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
}

const MenuItem = ({ asChild, children, className, onClick, disabled = false }: MenuItemProps) => {
  const Comp = asChild ? Slot : 'button';
  return (
    <Comp
      onClick={onClick}
      disabled={disabled}
      className={cn([
        'group flex h-8 w-full',
        'flex-row items-center',
        'rounded-md py-0.5 pl-2 pr-3',
        'transition-all duration-300 ease-in-out',
        'hover:bg-gray-lightest',
        'active:scale-95',
        'disabled:opacity-50 disabled:hover:bg-transparent',
        className,
      ])}
    >
      {children}
    </Comp>
  );
};

export default MenuItem;
